import { systemAccountCollection } from "../../config/collectionsConfig";

export const GetBusinessProfile = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch(StartLoadingProfile());
      dispatch({
        type: "GET_BUSINESS_PROFILE",
        payload: {
          ...getState().firebase.profile,
          id: getState().firebase.auth.uid,
        },
      });
    } catch (e) {
      console.log(e);
    }
  };
};

export const ClearProfile = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    // dispatch(StartLoadingProfile());
    dispatch({
      type: "CLEAR_BUSINESS_PROFILE",
    });
  };
};

export const GetBusinessSystemAccount = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOADING_REGION" });
      const firestore = getFirestore();
      firestore
        .collection(systemAccountCollection)
        .doc(getState().firebase.profile.region)
        .get()
        .then((account) => {
          dispatch({
            type: "GET_SYSTEM_ACCOUNT",
            payload: {
              ...account.data(),
              id: getState().profile.profile.region,
            },
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_SYSTEM_ACCOUNT_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_SYSTEM_ACCOUNT_ERROR", payload: e });
    }
  };
};

export const GetSystemUser = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOADING_SYSTEM_USER" });
      const firestore = getFirestore();
      firestore
        .collection("systemUser")
        .doc(getState().firebase.profile.system_user)
        .get()
        .then((account) => {
          dispatch({
            type: "GET_SYSTEM_USER",
            payload: {
              phone: account.data().phoneNumber,
              banks: account.data().listOfBanks,
              name: account.data().fullname,
              id: getState().profile.profile.region,
            },
          });
        })
        .catch((e) => {
          dispatch({ type: "GET_SYSTEM_USER_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_SYSTEM_USER_ERROR", payload: e });
    }
  };
};

export const GetBankInfos = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOADING_BANKS" });
      const firestore = getFirestore();
      if (
        getState().profile.profile.system_user !== null &&
        getState().profile.profile.system_user !== undefined &&
        getState().profile.profile.system_user.length !== 0
      ) {
        firestore
          .collection("banks")
          .where("systemUserID", "==", getState().profile.profile.system_user)
          .get()
          .then((banks) => {
            console.log(banks.size);
            const bbs = [];
            banks.forEach((bank) => {
              bbs.push({ ...bank.data(), id: bank.id });
            });
            dispatch({
              type: "GET_DEPOSIT_BANKS",
              payload: bbs,
            });
          })
          .catch((e) => {
            dispatch({ type: "GET_DEPOSIT_BANKS_ERROR", payload: e });
          });
      } else {
        dispatch({
          type: "GET_DEPOSIT_BANKS_ERROR",
          payload: "No System User",
        });
      }
    } catch (e) {
      dispatch({ type: "GET_DEPOSIT_BANKS_ERROR", payload: e });
    }
  };
};

export const StartLoadingProfile = () => {
  return {
    type: "LOADING_PROFILE",
  };
};
